// extracted by mini-css-extract-plugin
export default {"mfe-page":"index__mfe-page___9Dypm"};